
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import Tabs from './Tabs.vue'
import Content from './Content.vue'
import { stationeryGroupName } from '@xt/client/dataSource/stationery/index'

@Component({
  components: {
    Tabs,
    Content
  }
})
export default class CategoryPanel extends Vue {
  active: number = 0
  scrollTop: number = 895 + 16

  hasScrollTop: boolean = false
  ob: IntersectionObserver | null = null
  @Ref()
  headerLine: HTMLDivElement

  get tabList() {
    return stationeryGroupName
  }

  @Emit('show-qrcode-pop')
  handleShowQrcode(item) {
    return item
  }

  // 切换tab
  handleChange(index: number) {
    if (this.active === index) return

    this.active = index

    // 切换的时候自动顶上来
    window.scrollTo({
      top: this.scrollTop,
      behavior: 'smooth'
    })
    this.hasScrollTop = true
  }

  created(): void {}

  mounted(): void {
    this.ob = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        this.hasScrollTop = entries[0].boundingClientRect.top >= 50 ? true : false
      },
      { rootMargin: '-50px 0px', threshold: [0, 1] }
    )
    this.ob.observe(this.headerLine)
  }

  beforeUpdate(): void {}

  beforeDestroy(): void {}

  updated(): void {}

  destroyed(): void {
    this.ob?.disconnect()
  }
}
